import { render, staticRenderFns } from "./MenuInternoCadastros.vue?vue&type=template&id=78c63794&scoped=true&"
import script from "./MenuInternoCadastros.vue?vue&type=script&lang=js&"
export * from "./MenuInternoCadastros.vue?vue&type=script&lang=js&"
import style0 from "./MenuInternoCadastros.vue?vue&type=style&index=0&id=78c63794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c63794",
  null
  
)

export default component.exports